import React, { useState } from "react";
import "../styles/Proceso.scss";

const STEPS = [
  {
    step: "01",
    title: "Diagnóstico y Objetivos",
    desc: "Entendemos tu negocio, tu oferta y el tipo de cliente que quieres atraer. Definimos metas claras y una ruta simple para lograr resultados.",
    tags: ["Brief rápido", "Objetivos", "Prioridades"],
  },
  {
    step: "02",
    title: "Estrategia y Plan",
    desc: "Construimos un plan general: contenido, campañas y la estructura digital necesaria para convertir. Todo alineado a tu presupuesto y ritmo.",
    tags: ["Estrategia", "Creativos", "Estructura"],
  },
  {
    step: "03",
    title: "Implementación",
    desc: "Ejecutamos la estrategia: contenido constante, campañas optimizadas y herramientas que mejoran la atención y la conversión (landing, bots, automatización).",
    tags: ["Contenido", "Campañas", "Landing", "Bots", "n8n"],
  },
  {
    step: "04",
    title: "Optimización y Escalamiento",
    desc: "Medimos, ajustamos y escalamos. Mejoramos anuncios, mensajes y procesos para aumentar conversiones y mantener crecimiento sostenible.",
    tags: ["Optimización", "Reportes", "Mejoras continuas"],
  },
];

export default function Proceso() {
  const [active, setActive] = useState(0);

  return (
    <section className="ovit-proceso" id="proceso">
      <div className="ovit-proceso__bg" aria-hidden="true">
        <div className="ovit-proceso__grid" />
        <div className="ovit-proceso__glow ovit-proceso__glow--1" />
        <div className="ovit-proceso__glow ovit-proceso__glow--2" />
      </div>

      <div className="ovit-proceso__container">
        <header className="ovit-proceso__header">
          <h2 className="ovit-proceso__title">
            Nuestro <span>Proceso</span>
          </h2>
          <p className="ovit-proceso__subtitle">
            Un método claro para construir una presencia digital sólida: atraer, convertir y escalar.
            Combinamos estrategia, ejecución y automatización para lograr resultados reales.
          </p>
        </header>

        <div className="ovit-proceso__layout">
          {/* Left: Steps list */}
          <div className="ovit-proceso__steps" role="tablist" aria-label="Proceso OVIT">
            {STEPS.map((s, idx) => (
              <button
                key={s.step}
                className={`ovit-step ${active === idx ? "is-active" : ""}`}
                onClick={() => setActive(idx)}
                type="button"
                role="tab"
                aria-selected={active === idx}
              >
                <div className="ovit-step__badge">
                  <span className="ovit-step__num">{s.step}</span>
                </div>

                <div className="ovit-step__info">
                  <span className="ovit-step__title">{s.title}</span>
                  <span className="ovit-step__hint">{s.desc}</span>
                </div>

                <span className="ovit-step__arrow" aria-hidden="true">→</span>
              </button>
            ))}
          </div>

          {/* Right: Detail card */}
          <aside className="ovit-proceso__detail" aria-live="polite">
            <div className="ovit-detail__top">
              <div className="ovit-detail__kicker">
                <span className="ovit-detail__dot" aria-hidden="true" />
                <span>Así trabajamos</span>
              </div>

              <h3 className="ovit-detail__title">{STEPS[active].title}</h3>
              <p className="ovit-detail__desc">{STEPS[active].desc}</p>
            </div>

            <div className="ovit-detail__tags">
              {STEPS[active].tags.map((t) => (
                <span className="ovit-chip" key={t}>
                  {t}
                </span>
              ))}
            </div>

            <div className="ovit-detail__cta">
              <a href="https://wa.me/5215588093678?text=Hola%2C%20quiero%20iniciar%20mi%20estrategia%20digital.%20Me%20gustar%C3%ADa%20recibir%20una%20propuesta." className="ovit-proceso__btn" target="_blank" rel="noopener noreferrer">
                Quiero iniciar mi estrategia
              </a>
              <p className="ovit-detail__note">
                Te respondemos rápido y te sugerimos el camino más conveniente para tu negocio.
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
